<template>
  <div class="summary">
    <h2 class="heading-primary">{{ $t('shopping.overview_title') }}</h2>
    <ul class="list">
      <li>
        <span class="label">{{ $t('my_account.orders.subtotal') }}</span>
        <span>{{ cart?.price }}</span>
      </li>
      <li>
        <span class="label">{{ $t('shopping.quickcart.deliverycosts') }} </span>
        <span v-html="cart?.shipping_cost" class="subtotal"></span>
      </li>
      <li v-if="cart?.wrapping !== 'standard'" >
        <span class="label">{{ $t('shopping.basket.checkout.gift_wrapping') }} </span>
        <span v-html="cart?.wrapping_cost" class="subtotal"></span>
      </li>
      <li v-if="cart?.discount_number">
        <span class="label">{{ $t('my_account.orders.discount') }}</span>
        <span class="subtotal">{{ cart?.discount }}</span>
      </li>
      <li>
      <span class="label">
        <span class="highlight">{{ $t('shopping.quickcart.total') }}</span> ({{ $t('shopping.quickcart.incl') }})
      </span>
        <span class="highlight">{{ cart?.total_price }}</span>
      </li>
    </ul>
    <button
        type="submit"
        name="submit"
        class="b b-A btn-primary"
        @click.prevent="() => {setFormSubmitPressed(true); emit('submit')}"
    >
      {{ $t('shopping.basket.checkout.purchase') }}
    </button>
  </div>
</template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { showSnackbar, parseCurrency } from '@/helper'
import { useAuth } from '@/app/Checkout/composables/useAuth'
import { useUser } from '@/app/Checkout/composables/useUser'
import { useCheckout } from '@/app/Checkout/composables/useCheckout'
import {
  isAdyenValid as isAdyenValidRef,
  formSubmitPressed as formSubmitPressedRef,
  setFormSubmitPressed
} from '@/composables/useAdyen'

const { t } = useI18n()
const store = useStore()
const { isLoggedIn } = useAuth()
const { shippingAddress, activePaymentMethod } = useCheckout()
const isAdyenValid = isAdyenValidRef
const formSubmitPressed = formSubmitPressedRef

const { addresses, creatAddress } = useUser()
const cart = computed(() => store.state.cart.cart)
const showWrappingCost = computed(() => parseCurrency(cart.wrapping_cost) > 0)

const emit = defineEmits(['submit'])
</script>
